<div class="scrolldown" (click)="scrollDown()">
  <span></span>
  <span></span>
  <span></span>
</div>
